"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var BrokenIcon = function BrokenIcon(props) {
  return _react["default"].createElement("svg", {
    className: props.className,
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Icon indicating that this content could not be loaded",
    role: "img"
  }, _react["default"].createElement("title", null, "Icon indicating that this content could not be loaded"), _react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("g", {
    transform: "translate(-821.000000, -178.000000)",
    fill: props.color || "#CCCCCC"
  }, _react["default"].createElement("g", null, _react["default"].createElement("g", {
    transform: "translate(159.000000, 60.000000)"
  }, _react["default"].createElement("g", {
    transform: "translate(524.000000, 118.000000)"
  }, _react["default"].createElement("g", {
    transform: "translate(138.000000, 0.000000)"
  }, _react["default"].createElement("path", {
    d: "M21.4730968,0 L13.4090913,8.54732147 L21.4139932,16.5522233 L13.9331714,24.0330451 L21.8734744,31.9733481 L13.9592172,39.8876053 L14.0716119,40 L6,40 C2.6862915,40 4.05812251e-16,37.3137085 0,34 L0,6 C-4.05812251e-16,2.6862915 2.6862915,6.08718376e-16 6,0 L21.4730968,0 Z M25.5975302,0 L34,0 C37.3137085,-6.08718376e-16 40,2.6862915 40,6 L40,34 C40,37.3137085 37.3137085,40 34,40 L18.0894632,40 L26.1161151,31.9733481 L18.175812,24.0330451 L25.6566338,16.5522233 L17.5909087,8.48649817 L25.5975302,4.64905892e-16 Z"
  }))))))));
};

var _default = BrokenIcon;
exports["default"] = _default;